export default __webpack_public_path__ + "static/media/delete_red.407b6aff.svg";